import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-amortization-table',
  templateUrl: './amortization-table.component.html',
  styleUrls: ['./amortization-table.component.scss']
})
export class AmortizationTableComponent implements OnInit {

  @Input() contractDetails: any
  paymentEdit: any;
  editPayForm: FormGroup;
  missingFieldMsg = false;
  errorMsg = false;
  @ViewChild('closeBtn') closeBtn: ElementRef;

  constructor(private appComp: AppComponent, private router: Router, private formBuilder: FormBuilder, private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.editPayForm = this.formBuilder.group({
      reference: [""],
      paid: ["", Validators.required],
    });
  }

  markPaid(payment:any){
    console.log(payment);
    this.paymentEdit = payment;
    if(this.paymentEdit){
      this.editPayForm.patchValue({
        reference: this.paymentEdit.reference,
        paid: this.paymentEdit.paid
      })
    }
  }


  editPayment(){
    this.appComp.loading = true;
    this.missingFieldMsg = false;
    if (this.editPayForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.editPayForm.getRawValue();
    this.paymentEdit.reference = formObj.reference;
    console.log(this.paymentEdit);
    this.paymentEdit.paid = formObj.paid;
    // if(typeof formObj.active == "string"){
    //   formObj.active = formObj.active == 'true' ? true : false;
    // }
    let contract = {
      ...this.contractDetails
    }
    //stringify
    let keys = Object.keys(contract);
    keys.forEach((key, index) => {
      
      if(typeof contract[key] == 'object'){
        console.log(key);
        if(contract[key] != null){
          contract[key] = JSON.stringify(contract[key]);
        }
        
      }
    });

    console.log(contract);
    if(contract.txtMsgs == "null"){
      contract.txtMsgs = null;
    }
    this.authService.updateLoanContract(contract).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
      // this.router.navigateByUrl('/contracts');
    }, err=>{
      console.log(err);
      this.appComp.loading = false;
      this.errorMsg = true;
    })


    console.log(this.paymentEdit);
    this.appComp.loading = false;

  }

}
